export default __webpack_public_path__ + "static/media/imgBuddha.97fdaa27.png";